import { InjectionToken } from '@angular/core';

/**
 * Основной язык фолбэка. Используется как `defaultLang` ngx-translate и как первое
 * звено цепочки {@link TRANSLATION_FALLBACK_CHAIN}.
 *
 * Важно: значение должно быть константой и не зависеть от языка браузера. ngx-translate
 * применяет `defaultLang` только при условии `defaultLang !== currentLang`, поэтому
 * вычисление фолбэка из браузера отключало бы его ровно у тех пользователей, чей
 * браузер совпадает с языком интерфейса.
 */
export const TRANSLATION_PRIMARY_FALLBACK_LANG = 'en';

/**
 * Цепочка языков, по которой ищется перевод, отсутствующий в текущем языке.
 * Проверяется по порядку, побеждает первый язык, где ключ найден.
 *
 * Русского здесь нет намеренно: сервис переводов мержит цепочку `en → ru` на своей стороне
 * при сборке кэша, поэтому словарь любой локали уже содержит русские значения там, где нет
 * английских. Второе звено во фронте означало бы лишнюю загрузку ~300 KB. Английский остаётся
 * как стабильный `defaultLang` и страховка на ключи, которые фронт добавил раньше, чем их
 * успели завести в сервисе.
 */
export const TRANSLATION_FALLBACK_CHAIN: readonly string[] = [TRANSLATION_PRIMARY_FALLBACK_LANG];

/** DI-токен цепочки фолбэка, чтобы её можно было переопределить в тестах. */
export const TRANSLATION_FALLBACK_LANGS = new InjectionToken<readonly string[]>(
  'TRANSLATION_FALLBACK_LANGS',
  {
    factory: () => TRANSLATION_FALLBACK_CHAIN,
  },
);
